<p-dialog
	[visible]="visible"
	(visibleChange)="onVisibleChange($event)"
	[modal]="true"
	[dismissableMask]="false"
	[closable]="dismissable"
	[closeOnEscape]="dismissable"
	[draggable]="false"
	[resizable]="false"
	appendTo="body"
	[style]="{ width: '28rem' }"
	[breakpoints]="{ '640px': '95vw' }"
>
	<ng-template pTemplate="header">
		<div class="flex align-items-center gap-2">
			<i
				class="pi pi-exclamation-triangle text-xl"
				[ngClass]="destructive ? 'text-red-500' : 'text-primary'"
			></i>
			<span class="font-bold text-lg">{{ header }}</span>
		</div>
	</ng-template>

	<p class="m-0 line-height-3">{{ message }}</p>
	<div
		*ngIf="items.length"
		class="surface-100 border-round p-3 mt-3 text-sm overflow-auto"
		style="max-height: 9rem"
		data-testid="bulk-access-confirm-items"
	>
		<div *ngFor="let item of items" class="py-1">{{ item }}</div>
	</div>

	<!-- DOVE-2676 — undo countdown; nothing has been sent yet. -->
	<div *ngIf="showCountdown" class="mt-3" data-testid="bulk-access-countdown">
		<p-progressBar
			[value]="phase === 'countdown' ? progress : 0"
			[showValue]="false"
			[style]="{ height: '0.375rem' }"
		/>
		<div class="text-sm text-color-secondary mt-2">
			{{ phase === 'countdown' ? countdownNote : 'Undo is no longer available' }}
		</div>
	</div>

	<p-message
		*ngIf="phase === 'failed' && error"
		severity="error"
		[text]="error"
		styleClass="w-full justify-content-start mt-3"
		data-testid="bulk-access-confirm-error"
	/>

	<ng-template pTemplate="footer">
		<!-- A single row is sent straight from here: spinner on the button, as before the countdown. -->
		<ng-container *ngIf="phase === 'confirm' || (phase === 'sending' && !undoable)">
			<p-button
				label="Cancel"
				severity="secondary"
				[outlined]="true"
				[disabled]="phase === 'sending'"
				(onClick)="cancel.emit()"
			/>
			<p-button
				[label]="acceptLabel"
				[severity]="destructive ? 'danger' : 'primary'"
				[loading]="phase === 'sending'"
				(onClick)="accept.emit()"
			/>
		</ng-container>
		<p-button
			*ngIf="phase === 'countdown'"
			label="Undo"
			icon="pi pi-undo"
			[badge]="secondsLeft + ''"
			(onClick)="undo.emit()"
		/>
		<p-button *ngIf="phase === 'sending' && undoable" [label]="sendingLabel" [loading]="true" [disabled]="true" />
		<ng-container *ngIf="phase === 'failed'">
			<p-button label="Close" severity="secondary" [outlined]="true" (onClick)="cancel.emit()" />
			<p-button label="Try again" (onClick)="retry.emit()" />
		</ng-container>
	</ng-template>
</p-dialog>
